import type { Currency, UnitCode } from '~/graphql/graphql';

type PriceableInventory = {
  id: string;
  unitPrice?: {
    unit: UnitCode;
    price?: { amount: number; currency: Currency } | null;
  } | null;
};

/**
 * Carries a buyer's price edit forward across a fresh server fetch (page load, seller add). The
 * flag and the edited price must move together: preserving `isPriceChanged` alone left the badge
 * showing "edited" while the price itself silently reverted to the server's fresh value.
 */
export function mergePriceChangesAcrossRefresh<T extends PriceableInventory>(
  incoming: readonly T[],
  previous: readonly (T & { isPriceChanged: boolean })[]
): (T & { isPriceChanged: boolean })[] {
  const previousById = new Map(
    previous.map((inventory) => [inventory.id, inventory])
  );
  return incoming.map((inventory) => {
    const prior = previousById.get(inventory.id);
    return prior?.isPriceChanged
      ? { ...inventory, unitPrice: prior.unitPrice, isPriceChanged: true }
      : { ...inventory, isPriceChanged: false };
  });
}
